import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { searchGeneral } from "../api";
import { ManagementListLoading } from "../components/management/ManagementFilterHeader";
import "../assets/css/windows.css";
import "../assets/css/bookings.css";
import "../assets/css/management.css";
import "../assets/css/search.css";

function withFocusRefresh(path) {
  if (!path) return path;
  const [base, hash = ""] = String(path).split("#");
  const [pathname, search = ""] = base.split("?");
  const params = new URLSearchParams(search);
  if (params.has("focusId")) params.set("focusTick", `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);
  const nextSearch = params.toString();
  return `${pathname}${nextSearch ? `?${nextSearch}` : ""}${hash ? `#${hash}` : ""}`;
}

function SectionResults({ section }) {
  const navigate = useNavigate();
  return (
    <section className="general_search_section">
      <div className="general_search_section_head">
        <h2>{section.title}</h2>
        <span>{section.items?.length || 0} risultati</span>
      </div>
      <div className="general_search_results_grid">
        {(section.items || []).map((item) => (
          <button key={`${section.key}-${item.id}`} type="button" className="general_search_result_card" onClick={() => navigate(withFocusRefresh(item.path || section.path || "/app/search"))}>
            <strong>{item.title}</strong>
            <span>{item.subtitle || section.title}</span>
            {item.meta && <em>{item.meta}</em>}
          </button>
        ))}
      </div>
    </section>
  );
}

export default function Search() {
  const [params, setParams] = useSearchParams();
  const initialQuery = params.get("q") || "";
  const [query, setQuery] = useState(initialQuery);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setQuery(params.get("q") || "");
  }, [params]);

  useEffect(() => {
    const q = query.trim();
    setError("");

    if (q.length < 2) {
      setSections([]);
      setLoading(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    const timer = window.setTimeout(async () => {
      try {
        const data = await searchGeneral({ q });
        if (!active) return;
        setSections(Array.isArray(data?.sections) ? data.sections : []);
      } catch {
        if (!active) return;
        setSections([]);
        setError("Impossibile completare la ricerca");
      } finally {
        if (active) setLoading(false);
      }
    }, 180);

    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, [query]);

  const total = useMemo(() => sections.reduce((sum, section) => sum + (section.items?.length || 0), 0), [sections]);

  function submitSearch(event) {
    event.preventDefault();
    const q = query.trim();
    setParams(q ? { q } : {});
  }

  return (
    <section className="window_page bookings_page management_page management_shared_page general_search_page">
      <div className="window_banner">
        <div className="window_banner_copy">
          <h1>RICERCA</h1>
          <p>Ricerca globale su finestre, Planning, Soggiorni, Preventivi, Fatture, Fatturazione, camere, clienti, configurazioni e report. I risultati sono suddivisi per sezione.</p>
        </div>
      </div>

      <form className="booking_toolbar management_toolbar management_table_toolbar management_shared_toolbar general_search_toolbar" onSubmit={submitSearch}>
        <input className="management_search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Cerca qualsiasi informazione in VestaMNG" />
        <div className="management_toolbar_results">
          <strong className="management_results_count">Risultati: {loading ? "..." : total}</strong>
        </div>
      </form>

      <div className="general_search_body">
        {query.trim().length < 2 && <div className="management_table_visible_status">Inserisci almeno 2 caratteri per avviare la ricerca</div>}
        {query.trim().length >= 2 && loading && <ManagementListLoading label="Ricerca in corso" />}
        {!loading && error && <div className="management_table_visible_status is_error">{error}</div>}
        {!loading && !error && query.trim().length >= 2 && total === 0 && <div className="management_table_visible_status">Nessuna Corrispondenza Trovata</div>}
        {!loading && !error && sections.map((section) => <SectionResults key={section.key} section={section} />)}
      </div>
    </section>
  );
}
